import moment from "moment";
import downArrow from "../../../assets/arrow-down.png";
import dropdownIcon from "../../../assets/dropdown_blue.svg";
import dropdownIconBlack from "../../../assets/dropdown.svg";

export const FOLLOW_UP_STATUS_OPTION = [
  {
    id: 1,
    name: "New",
    value: "new",
  },
  {
    id: 2,
    name: "Appointment Scheduled",
    value: "appointment_scheduled",
  },
  {
    id: 3,
    name: "Cancelled",
    value: "cancelled",
  },
  {
    id: 4,
    name: "Lost To competitor",
    value: "lost_to_competitor",
  },
  {
    id: 5,
    name: "Service Not Available",
    value: "service_not_available",
  },
  {
    id: 6,
    name: "Looking for discount",
    value: "looking_for_discount",
  },
  {
    id: 7,
    name: "Pricing Issue",
    value: "pricing_issue",
  },
  {
    id: 8,
    name: "Call Back Later",
    value: "call_back_later",
  },
  {
    id: 9,
    name: "Do Not Disturb",
    value: "do_not_disturb",
  },
  {
    id: 10,
    name: "Out Of Service",
    value: "out_of_service",
  },
  {
    id: 11,
    name: "Switched Off",
    value: "switched_off",
  },
  {
    id: 12,
    name: "Incoming Call Not Available",
    value: "incoming_call_not_available",
  },
  {
    id: 13,
    name: "Patient Not Interested",
    value: "patient_not_interested",
  },
  {
    id: 14,
    name: "Report Pending",
    value: "report_pending",
  },
  {
    id: 15,
    name: "Reschedule",
    value: "reschedule",
  },
  {
    id: 16,
    name: "Disconnected",
    value: "disconnected",
  },
  {
    id: 17,
    name: "Query Resolved",
    value: "query_resolved",
  },
  {
    id: 18,
    name: "In Progress",
    value: "in_progress",
  },
  {
    id: 19,
    name: "Not Answering",
    value: "not_answering",
  },
  {
    id: 20,
    name: "Book Appointment",
    value: "book_appointment",
  },
  {
    id: 21,
    name: "Other",
    value: "other",
  },
];

export const NEW_LEAD_SOURCE_OPTION = [
  {
    id: 1,
    name: "Phone Inquiry",
    value: "Phone Inquiry",
  },
  {
    id: 2,
    name: "Website/Online form",
    value: "Website/Online form",
  },
  {
    id: 3,
    name: "Advertisement",
    value: "Advertisement",
  },
  {
    id: 4,
    name: "Facebook Campaign",
    value: "Facebook Campaign",
  },
  {
    id: 5,
    name: "Whatsapp Campaign",
    value: "Whatsapp Campaign",
  },
  {
    id: 6,
    name: "Instagram Campaign",
    value: "Instagram Campaign",
  },
  {
    id: 7,
    name: "Telegram",
    value: "Telegram",
  },
  {
    id: 8,
    name: "Justdial",
    value: "Justdial",
  },
  {
    id: 9,
    name: "Practo",
    value: "Practo",
  },
  {
    id: 10,
    name: "Lybrate",
    value: "Lybrate",
  },
  {
    id: 11,
    name: "Word of mouth",
    value: "Word of mouth",
  },
  {
    id: 12,
    name: "Doctor Referral",
    value: "Doctor Referral",
  },
  {
    id: 13,
    name: "Patient Referral",
    value: "Patient Referral",
  },
  {
    id: 14,
    name: "Health screenings/Campaigns",
    value: "Health screenings/Campaigns",
  },
  {
    id: 15,
    name: "Direct Mail",
    value: "Direct Mail",
  },
  {
    id: 16,
    name: "Partner Referral",
    value: "Partner Referral",
  },
  {
    id: 17,
    name: "Walk-In",
    value: "Walk-In",
  },
  {
    id: 18,
    name: "Google Ads",
    value: "Google Ads",
  },
  {
    id: 19,
    name: "Cold Call",
    value: "Cold Call",
  },
  {
    id: 20,
    name: "Offline Campaign",
    value: "Offline Campaign",
  },
  {
    id: 21,
    name: "Purchased lead",
    value: "Purchased lead",
  },
  {
    id: 22,
    name: "Repeated Customer",
    value: "Repeated Customer",
  },
  {
    id: 23,
    name: "Newspaper",
    value: "Newspaper",
  },
  {
    id: 24,
    name: "Twitter",
    value: "Twitter",
  },
  {
    id: 25,
    name: "LinkedIn",
    value: "LinkedIn",
  },
  {
    id: 26,
    name: "Other",
    value: "Other",
  },
];

export const NEW_LEAD_QUERY_DATE_OPTION = [
  {
    id: 1,
    name: "Newest First",
    value: "newest_first",
  },
  {
    id: 2,
    name: "Oldest First",
    value: "oldest_first",
  },
];

export const NEW_LEAD_AMOUNT_OPTION = [
  {
    id: 1,
    name: "Low to High",
    value: "asc",
  },
  {
    id: 2,
    name: "High to Low",
    value: "desc",
  },
];

export const FOLLOW_UP_TABLE_HEADER_LIST = [
  {
    id: 1,
    title: "Patient Information",
  },
  {
    id: 2,
    title: "Mobile Number",
  },
  {
    id: 3,
    title: "View eRx",
  },
  {
    id: 4,
    title: "Doctor",
    mobileFilterTitle: "Doctor",
    filter: true,
    showFilter: false,
    label: "doctor_filter",
    menuData: [],
  },
  {
    id: 5,
    title: "Procedure",
    mobileFilterTitle: "Procedure",
    filter: true,
    showFilter: false,
    label: "procedure_filter",
    menuData: [],
  },
  {
    id: 6,
    title: "Amount",
    mobileFilterTitle: "Amount",
    filter: true,
    showFilter: false,
    label: "amount_sort_order",
    menuData: [...NEW_LEAD_AMOUNT_OPTION],
  },
  {
    id: 7,
    title: "Created On",
  },
  {
    id: 8,
    title: "Follow Up",
  },
  {
    id: 9,
    title: "Status",
    mobileFilterTitle: "Status",
    label: "status_filter",
    filter: true,
    showFilter: false,
    menuData: [...FOLLOW_UP_STATUS_OPTION],
  },
  {
    id: 10,
    title: "Actions",
  },
];

export const FOLLOW_UP_HEADER_LIST = {
  PATIENT_INFORMATION: "Patient Information",
  MOBILE_NUMBER: "Mobile Number",
  VIEW_ERX: "View eRx",
  DOCTOR: "Doctor",
  DOCTOR_OR_RESOURCE: "Doctor /Resource",
  AMOUNT: "Amount",
  FOLLOW_UP_CREATED_ON: "Created On",
  FOLLOW_UP_DATE: "Follow Up",
  STATUS: "Status",
};

export const NEW_LEAD_TABLE_HEADER_LIST = [
  {
    id: 1,
    title: "Patient Information",
  },
  {
    id: 2,
    title: "Mobile Number",
  },

  {
    id: 3,
    title: "Source",
    label: "source_filter",
    mobileFilterTitle: "Source",
    className: "nlvmc-source-filter-dropdown",
    filter: true,
    showFilter: false,
    menuData: [],
  },
  {
    id: 5,
    title: "Doctor",
    label: "doctor_filter",
    mobileFilterTitle: "Doctor",
    filter: true,
    showFilter: false,
    menuData: [],
  },
  {
    id: 6,
    title: "Procedure",
    label: "procedure_filter",
    mobileFilterTitle: "Procedure",
    filter: true,
    showFilter: false,
    menuData: [],
  },
  {
    id: 7,
    title: "Amount",
    label: "amount_sort_order",
    mobileFilterTitle: "Amonut",
    filter: true,
    showFilter: false,
    menuData: [...NEW_LEAD_AMOUNT_OPTION],
  },
  {
    id: 4,
    title: "Created On",
    label: "created_on_filter",
    mobileFilterTitle: "Created On",
  },
  {
    id: 4,
    title: "Follow-Up Date",
    label: "follow_up_date_filter",
    mobileFilterTitle: "Follow-Up Date",
  },
  {
    id: 8,
    title: "Status",
    label: "status_filter",
    mobileFilterTitle: "Status",
    filter: true,
    showFilter: false,
    menuData: [],
  },
  {
    id: 9,
    title: "Actions",
  },
];

export const NEW_LEAD_HEADER_LIST = {
  PATIENT_INFORMATION: "Name",
  MOBILE_NUMBER: "Mobile Number",
  SOURCE: "Source",
  DOCTOR: "Doctor",
  PROCEDURE: "Procedure",
  AMOUNT: "Amount",
  STATUS: "Status",
  CREATED_ON: "Created On",
  FOLLOW_UP_DATE: "Follow-Up Date",
};

export const FOLLOW_UP_DROPDOWN = [
  {
    id: 1,
    title: "FOLLOW - UP",
    value: 0,
  },
  {
    id: 2,
    title: "NEW LEAD",
    value: 1,
  },
  // {
  //   id: 2,
  //   title: "CAMPAIGN LIST",
  //   value: 2,
  // },
];

export const FOLLOW_UP_STATUS_COLOR = [
  {
    name: "new",
    color: "#17BAE0",
    backgroundColor: "#E8F8FC",
  },
  {
    name: "appointment scheduled",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "cancelled",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "lost to competitor",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "service not available",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "looking for discount",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "pricing issue",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "call back later",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "do not disturb",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "out of service",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "switched off",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "incoming call not available",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "patient not interested",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "report pending",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "reschedule",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "disconnected",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "query resolved",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "in progress",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "not answering",
    color: "#F82323",
    backgroundColor: "rgba(248, 35, 35, 0.10)",
  },
  {
    name: "book appointment",
    color: "#00B569",
    backgroundColor: "#E5F8F0",
  },
  {
    name: "other",
    color: "#B2B2B2",
    backgroundColor: "#F8F8F8",
  },
];

export const DEFAULT_CONSULTATION_TYPES = [
  {
    name: "Tele-Consult Regular",
    value: "teleconsult regular",
  },
  {
    name: "Tele-Consult Follow-Up",
    value: "teleconsult follow-up",
  },
  {
    name: "In-Clinic Regular",
    value: "in-clinic regular",
  },
  {
    name: "In-Clinic Follow-Up",
    value: "in-clinic follow-up",
  },
  {
    name: "Instant",
    value: "instant",
  },
];

export const NEW_LEAD_DEFAULT_CONSULTATION_TYPES = [
  {
    name: "Tele-Consult Regular",
    value: "teleconsult regular",
  },
  {
    name: "Tele-Consult Follow-Up",
    value: "teleconsult follow-up",
  },
  {
    name: "In-Clinic Regular",
    value: "in-clinic regular",
  },
  {
    name: "In-Clinic Follow-Up",
    value: "in-clinic follow-up",
  },
  {
    name: "Instant",
    value: "instant",
  },
];

export const FOLLOW_UP_LEAD_DETAILS = [
  {
    id: 1,
    title: "Name",
    label: "patient_name",
    value: "",
  },
  {
    id: 2,
    title: "Email ID",
    label: "email",
    value: "",
  },
  {
    id: 3,
    title: "Gender",
    label: "patient_gender",
    value: "",
  },
  {
    id: 4,
    title: "State",
    label: "patient_state_name",
    value: "",
  },
  {
    id: 5,
    title: "Date of Birth",
    label: "patient_dob",
    value: "",
  },
  {
    id: 6,
    title: "Pincode",
    label: "patient_pincode",
    value: "",
  },
  {
    id: 7,
    title: "Address",
    label: "patient_full_address",
    value: "",
  },
  {
    id: 8,
    title: "City",
    label: "patient_city",
    value: "",
  },
];

export const NEW_LEAD_DETAILS = [
  {
    id: 1,
    title: "Name",
    label: "patient_name",
    value: "",
  },
  {
    id: 2,
    title: "Lead Source",
    label: "source",
    value: "",
  },
  {
    id: 3,
    title: "Pin Code",
    label: "patient_pincode",
    value: "",
  },
  {
    id: 4,
    title: "Description",
    label: "description",
    value: "",
  },
  {
    id: 5,
    title: "State",
    label: "state_name",
    value: "",
  },
  {
    id: 6,
    title: "Lead Query",
    label: "query",
    value: "",
  },
];

export const LEAD_QUERY_OPTIONS = [
  {
    id: 1,
    label: "Doctor/Specialization",
    value: "Doctor/Specialization",
  },
  {
    id: 2,
    label: "Diagnostic/Test",
    value: "Diagnostic/Test",
  },
  {
    id: 3,
    label: "Report Delivery",
    value: "Report Delivery",
  },
  {
    id: 4,
    label: "Home Sample Collection",
    value: "Home Sample Collection",
  },
  {
    id: 5,
    label: "OPD Inquiry",
    value: "OPD Inquiry",
  },
  {
    id: 6,
    label: "IPD Inquiry",
    value: "IPD Inquiry",
  },
  {
    id: 7,
    label: "Pharmacy-Medicine",
    value: "Pharmacy-Medicine",
  },
  {
    id: 8,
    label: "Medicine Delivery",
    value: "Medicine Delivery",
  },
  {
    id: 9,
    label: "Complaint/Escalation",
    value: "Complaint/Escalation",
  },
  {
    id: 10,
    label: "Health Packages",
    value: "Health Packages",
  },
  {
    id: 11,
    label: "Emergency Services",
    value: "Emergency Services",
  },
  {
    id: 12,
    label: "Treatment/Service Inquiry",
    value: "Treatment/Service Inquiry",
  },
  {
    id: 13,
    label: "Patient Medical Condition",
    value: "Patient Medical Condition",
  },
  {
    id: 14,
    label: "Bed Charges",
    value: "Bed Charges",
  },
  {
    id: 15,
    label: "OT Related Inquiry",
    value: "OT Related Inquiry",
  },
  {
    id: 16,
    label: "Health Camp",
    value: "Health Camp",
  },
  {
    id: 17,
    label: "Insurance Inquiry",
    value: "Insurance Inquiry",
  },
  {
    id: 18,
    label: "Admission Inquiry",
    value: "Admission Inquiry",
  },
  {
    id: 18,
    label: "Other",
    value: "Other",
  },
];

export const LEAD_SOURCE_OPTION = [
  {
    id: 1,
    label: "Phone Inquiry",
    value: "Phone Inquiry",
  },
  {
    id: 2,
    label: "Website/Online form",
    value: "Website/Online form",
  },
  {
    id: 3,
    label: "Advertisement",
    value: "Advertisement",
  },
  {
    id: 4,
    label: "Facebook Campaign",
    value: "Facebook Campaign",
  },
  {
    id: 5,
    label: "Whatsapp Campaign",
    value: "Whatsapp Campaign",
  },
  {
    id: 6,
    label: "Instagram Campaign",
    value: "Instagram Campaign",
  },
  {
    id: 7,
    label: "Telegram",
    value: "Telegram",
  },
  {
    id: 8,
    label: "Justdial",
    value: "Justdial",
  },
  {
    id: 9,
    label: "Practo",
    value: "Practo",
  },
  {
    id: 10,
    label: "Lybrate",
    value: "Lybrate",
  },
  {
    id: 11,
    label: "Word of mouth",
    value: "Word of mouth",
  },
  {
    id: 12,
    label: "Doctor Referral",
    value: "Doctor Referral",
  },
  {
    id: 13,
    label: "Patient Referral",
    value: "Patient Referral",
  },
  {
    id: 14,
    label: "Health screenings/Campaigns",
    value: "Health screenings/Campaigns",
  },
  {
    id: 15,
    label: "Direct Mail",
    value: "Direct Mail",
  },
  {
    id: 16,
    label: "Partner Referral",
    value: "Partner Referral",
  },
  {
    id: 17,
    label: "Walk-In",
    value: "Walk-In",
  },
  {
    id: 18,
    label: "Google Ads",
    value: "Google Ads",
  },
  {
    id: 19,
    label: "Cold Call",
    value: "Cold Call",
  },
  {
    id: 20,
    label: "Offline Campaign",
    value: "Offline Campaign",
  },
  {
    id: 21,
    label: "Purchased lead",
    value: "Purchased lead",
  },
  {
    id: 22,
    label: "Repeated Customer",
    value: "Repeated Customer",
  },
  {
    id: 23,
    label: "Newspaper",
    value: "Newspaper",
  },
  {
    id: 24,
    label: "Twitter",
    value: "Twitter",
  },
  {
    id: 25,
    label: "LinkedIn",
    value: "LinkedIn",
  },
  {
    id: 26,
    label: "Other",
    value: "Other",
  },
];

export const LEAD_INFORMATION = [
  {
    id: 1,
    title: "Clinic",
    name: "clinic",
    value: "",
    inputType: "dropdown",
    icon: downArrow,
  },
  {
    id: 2,
    title: "Lead Query Date",
    name: "lead_query_date",
    value: new Date(),
    inputType: "datepicker",
  },
  {
    id: 3,
    title: "Lead Follow Up Date",
    name: "lead_follow_up_date",
    value: new Date(),
    inputType: "datepicker",
    type: "text",
  },
  {
    id: 3,
    title: "Lead Query",
    name: "lead_query",
    value: "",
    inputType: "autocomplete",
    options: [...LEAD_QUERY_OPTIONS],
    placeholder: "Select One - Optional",
    icon: downArrow,
  },
  {
    id: 3,
    title: "Lead Source",
    name: "lead_source",
    value: "",
    inputType: "autocomplete",
    options: [...LEAD_SOURCE_OPTION],
    placeholder: "Select One - Optional",
    icon: downArrow,
  },
  {
    id: 3,
    title: "Description",
    name: "description",
    value: "",
    inputType: "textarea",
    type: "text",
    maxLimit: 150,
    placeholder:
      "Add notes or remarks when receiving a lead, which will be reflected on the lead dashboard (Optional).",
  },
];

export const PATIENT_INFORMATION = [
  {
    id: 1,
    title: "Phone",
    name: "phone",
    value: "",
    inputType: "normal",
    type: "number",
    isMandatory: true,
  },
  {
    id: 2,
    title: "Name",
    name: "name",
    value: "",
    inputType: "normal",
    type: "text",
    prefixValue: "",
    prefixOption: [],
  },
  {
    id: 3,
    title: "Lead Follow Up Date",
    name: "lead_follow_up_date",
    value: "",
    inputType: "normal",
    type: "text",
  },
  {
    id: 3,
    title: "Lead Query",
    name: "lead_query",
    value: "",
    inputType: "dropdown",
    options: [...LEAD_QUERY_OPTIONS],
  },
  {
    id: 3,
    title: "Lead Source",
    name: "lead_source",
    value: "",
    inputType: "dropdown",
    options: [...LEAD_SOURCE_OPTION],
  },
  {
    id: 3,
    title: "Description",
    name: "description",
    value: "",
    inputType: "textarea",
    type: "text",
    maxLimit: 150,
  },
];

export const DEFAULT_ALERT_STATE = {
  show: false,
  title: "",
  content: "",
  type: "",
};

export const CAMPAIGN_TABLE_HEADER_LIST = [
  {
    id: 1,
    title: "Name",
    filter: true,
    showFilter: false,
    label: "campaign_name",
    menuData: [],
    className: "ctvmc-campaign-name",
    showFilterSearchbar: true,
    placeholderForSearch: "Search Campaign",
  },
  {
    id: 2,
    title: "Account Name",
    label: "account_name",
    className: "ctvmc-account-name",
  },
  {
    id: 3,
    title: "Campaign Date",
    label: "created_time",
    className: "ctvmc-campaign-date",
  },
  {
    id: 4,
    title: "Start Date",
    label: "start_time",
    className: "ctvmc-start-date",
  },
  {
    id: 5,
    title: "End Date",
    label: "stop_time",
    className: "ctvmc-end-date",
  },
  {
    id: 6,
    title: "Type",
    label: "type",
    className: "ctvmc-type",
  },
  {
    id: 7,
    title: "Impressions",
    label: "impressions",
    hoverText: "The number of times your ad was on screen.",
    className: "ctvmc-impression",
  },
  {
    id: 8,
    title: "Clicks",
    label: "clicks",
    hoverText: "The number of times your ad was clicked.",
    className: "ctvmc-clicks",
  },
  {
    id: 9,
    title: "Total Contacts",
    label: "contacts",
    hoverText:
      "Contacts that converted on your website for the first time in the same web session",
    className: "ctvmc-total-contacts",
  },
  {
    id: 10,
    title: "Conversion",
    label: "conversion",
    className: "ctvmc-conversion",
  },
  {
    id: 11,
    title: "Cost Per Contact",
    label: "const_per_contact",
    hoverText:
      "The amount of money spent on the ad divided by the number of contacts.",
    className: "ctvmc-const-per-contact",
  },
  {
    id: 12,
    title: "Amount Spent",
    label: "spend",
    hoverText:
      "The amount of money spent on the ad during the selected time frame.",
    className: "ctvmc-amount-spent",
  },
];

export const CAMPAIGN_TABLE_CONTENT = [
  {
    id: 1,
    campaign_name: "Lead Gen Campaign",
    account_name: "Apollo Clinic Ballygunge Phari",
    campaign_date: "07 Jan 2025",
    start_date: "09 Jan 2025",
    end_date: "20 Jan 2025",
    type: "Leads",
    impressions: "90,987",
    clicks: "1,800",
    total_contacts: "76",
    conversion: "1,800",
    const_per_contact: "₹ 7,517.14",
    amount_spent: "₹ 539.76764",
  },
  {
    id: 2,
    campaign_name: "Lead Gen Campaign",
    account_name: "Apollo Clinic Ballygunge Phari",
    campaign_date: "07 Jan 2025",
    start_date: "09 Jan 2025",
    end_date: "20 Jan 2025",
    type: "Leads",
    impressions: "90,987",
    clicks: "1,800",
    total_contacts: "76",
    conversion: "1,800",
    const_per_contact: "₹ 7,517.14",
    amount_spent: "₹ 539.76764",
  },
  {
    id: 3,
    campaign_name: "Lead Gen Campaign",
    account_name: "Apollo Clinic Ballygunge Phari",
    campaign_date: "07 Jan 2025",
    start_date: "09 Jan 2025",
    end_date: "20 Jan 2025",
    type: "Leads",
    impressions: "90,987",
    clicks: "1,800",
    total_contacts: "76",
    conversion: "1,800",
    const_per_contact: "₹ 7,517.14",
    amount_spent: "₹ 539.76764",
  },
  {
    id: 4,
    campaign_name: "Lead Gen Campaign",
    account_name: "Apollo Clinic Ballygunge Phari",
    campaign_date: "07 Jan 2025",
    start_date: "09 Jan 2025",
    end_date: "20 Jan 2025",
    type: "Leads",
    impressions: "90,987",
    clicks: "1,800",
    total_contacts: "76",
    conversion: "1,800",
    const_per_contact: "₹ 7,517.14",
    amount_spent: "₹ 539.76764",
  },
  {
    id: 5,
    campaign_name: "Lead Gen Campaign",
    account_name: "Apollo Clinic Ballygunge Phari",
    campaign_date: "07 Jan 2025",
    start_date: "09 Jan 2025",
    end_date: "20 Jan 2025",
    type: "Leads",
    impressions: "90,987",
    clicks: "1,800",
    total_contacts: "76",
    conversion: "1,800",
    const_per_contact: "₹ 7,517.14",
    amount_spent: "₹ 539.76764",
  },
  {
    id: 6,
    campaign_name: "Lead Gen Campaign",
    account_name: "Apollo Clinic Ballygunge Phari",
    campaign_date: "07 Jan 2025",
    start_date: "09 Jan 2025",
    end_date: "20 Jan 2025",
    type: "Leads",
    impressions: "90,987",
    clicks: "1,800",
    total_contacts: "76",
    conversion: "1,800",
    const_per_contact: "₹ 7,517.14",
    amount_spent: "₹ 539.76764",
  },
  {
    id: 7,
    campaign_name: "Lead Gen Campaign",
    account_name: "Apollo Clinic Ballygunge Phari",
    campaign_date: "07 Jan 2025",
    start_date: "09 Jan 2025",
    end_date: "20 Jan 2025",
    type: "Leads",
    impressions: "90,987",
    clicks: "1,800",
    total_contacts: "76",
    conversion: "1,800",
    const_per_contact: "₹ 7,517.14",
    amount_spent: "₹ 539.76764",
  },
  {
    id: 8,
    campaign_name: "Lead Gen Campaign",
    account_name: "Apollo Clinic Ballygunge Phari",
    campaign_date: "07 Jan 2025",
    start_date: "09 Jan 2025",
    end_date: "20 Jan 2025",
    type: "Leads",
    impressions: "90,987",
    clicks: "1,800",
    total_contacts: "76",
    conversion: "1,800",
    const_per_contact: "₹ 7,517.14",
    amount_spent: "₹ 539.76764",
  },
  {
    id: 9,
    campaign_name: "Lead Gen Campaign",
    account_name: "Apollo Clinic Ballygunge Phari",
    campaign_date: "07 Jan 2025",
    start_date: "09 Jan 2025",
    end_date: "20 Jan 2025",
    type: "Leads",
    impressions: "90,987",
    clicks: "1,800",
    total_contacts: "76",
    conversion: "1,800",
    const_per_contact: "₹ 7,517.14",
    amount_spent: "₹ 539.76764",
  },
  {
    id: 10,
    campaign_name: "Lead Gen Campaign",
    account_name: "Apollo Clinic Ballygunge Phari",
    campaign_date: "07 Jan 2025",
    start_date: "09 Jan 2025",
    end_date: "20 Jan 2025",
    type: "Leads",
    impressions: "90,987",
    clicks: "1,800",
    total_contacts: "76",
    conversion: "1,800",
    const_per_contact: "₹ 7,517.14",
    amount_spent: "₹ 539.76764",
  },
  {
    id: 11,
    campaign_name: "Lead Gen Campaign",
    account_name: "Apollo Clinic Ballygunge Phari",
    campaign_date: "07 Jan 2025",
    start_date: "09 Jan 2025",
    end_date: "20 Jan 2025",
    type: "Leads",
    impressions: "90,987",
    clicks: "1,800",
    total_contacts: "76",
    conversion: "1,800",
    const_per_contact: "₹ 7,517.14",
    amount_spent: "₹ 539.76764",
  },
];

export const CONTACTS_TABLE_HEADER = [
  {
    id: 1,
    title: "Name",
  },
  {
    id: 2,
    title: "Phone Number",
  },
  {
    id: 3,
    title: "Date Created",
  },
];

export const CONTACTS_DATA = [
  {
    id: 1,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 2,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 3,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 4,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 5,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 6,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 7,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 8,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 9,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 10,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 11,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 12,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 13,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 14,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 1,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 2,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 3,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 4,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 5,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 6,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 7,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 8,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 9,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 10,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 11,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 12,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 13,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 14,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 1,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 2,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 3,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 4,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 5,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 6,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 7,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 8,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 9,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 10,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 11,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 12,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 13,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 14,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 1,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 2,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 3,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 4,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 5,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 6,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 7,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 8,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 9,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 10,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 11,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 12,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 13,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 14,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 1,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 2,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 3,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 4,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 5,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 6,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 7,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 8,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 9,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 10,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 11,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 12,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 13,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 14,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 1,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 2,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 3,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 4,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 5,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 6,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 7,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 8,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 9,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 10,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 11,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 12,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 13,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 14,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 1,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 2,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 3,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 4,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 5,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 6,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 7,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 8,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 9,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 10,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 11,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 12,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 13,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 14,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 1,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 2,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 3,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 4,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 5,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 6,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 7,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 8,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 9,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 10,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 11,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 12,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 13,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 14,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 1,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 2,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 3,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 4,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 5,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 6,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 7,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 8,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 9,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 10,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 11,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 12,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 13,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 14,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 1,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 2,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 3,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 4,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 5,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 6,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 7,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 8,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 9,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 10,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 11,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 12,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 13,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
  {
    id: 14,
    name: "Dr. Ritika Jajoria",
    phone_no: "+91 9831766532",
    created_date: "26.12.2024",
  },
];

export function getDateByRanges(value) {
  let dateRange = {
    startDate: new Date(),
    endDate: new Date(),
  };
  const Today = new Date();
  const today = moment(new Date()).format("YYYY-MM-DD");

  const lastWeekMonth = moment(
    new Date(Today.getFullYear(), Today.getMonth() - 1, Today.getDate())
  ).format("YYYY-MM-DD");

  const lastWeek = moment(
    new Date(Today.getFullYear(), Today.getMonth(), Today.getDate() - 7)
  ).format("YYYY-MM-DD");

  if (!value || value == "Today") {
    dateRange = {
      startDate: today,
      endDate: today,
    };
  } else if (value == "Last 7 Days") {
    dateRange = {
      startDate: lastWeek,
      endDate: today,
    };
  } else if (value == "Last 30 Days") {
    dateRange = {
      startDate: lastWeekMonth,
      endDate: today,
    };
  }
  return dateRange;
}

export const dateFilter = [
  {
    name: "Today",
    value: "Today",
  },
  {
    name: "Last 7 Days",
    value: "Last 7 Days",
  },
  {
    name: "Last 30 Days",
    value: "Last 30 Days",
  },
  {
    name: "Custom Date Range",
    value: "Custom Date Range",
  },
];

export const STATUS_FILTER_LIST = [
  {
    id: 1,
    name: "Active",
    value: "ACTIVE",
    selected: true,
  },
  {
    id: 2,
    name: "Paused",
    value: "PAUSED",
    selected: false,
  },
  { id: 3, name: "Deleted", value: "DELETED", selected: false },
  { id: 4, name: "Completed", value: "COMPLETED", selected: false },
];

export const CAMPAIGN_HEADER_LIST = [
  {
    id: 2,
    type: "ACCOUNTS",
    title: "Accounts",
    mobileFilterTitle: "Accounts",
    filterIcon: dropdownIcon,
    filterType: "normal",
    showFilter: false,
    menuData: [],
    showFilterSearchbar: false,
    placeholderForSearch: "Search",
    className: "chc-accounts-dropdown-container",
    isFilterApplied: false,
    showCustomMenu: true,
  },
  {
    id: 1,
    type: "DATE_RANGE",
    title: "Date Range",
    mobileFilterTitle: "Date Range",
    filterIcon: dropdownIconBlack,
    filterType: "date",
    showFilter: false,
    menuData: [],
    isFilterApplied: false,
  },

  {
    id: 3,
    type: "STATUS",
    title: "Status",
    mobileFilterTitle: "Status",
    filterIcon: dropdownIcon,
    filterType: "normal", // "procedure",
    showFilter: false,
    menuData: [...STATUS_FILTER_LIST],
    className: "chc-status-dropdown",
    isFilterApplied: false,
  },
];

export const CAMPAIGN_MOBILE_TOTAL_DATA = [
  {
    id: 7,
    title: "Impressions",
    label: "totalImpressions",
    hoverText: "The number of times your ad was on screen.",
  },
  {
    id: 8,
    title: "Clicks",
    label: "totalClicks",
    hoverText: "The number of times your ad was clicked.",
  },
  {
    id: 9,
    title: "Total Contacts",
    label: "totalContacts",
    hoverText:
      "Contacts that converted on your website for the first time in the same web session",
  },
  {
    id: 10,
    title: "Conversion",
    label: "totalConversion",
  },
  {
    id: 11,
    title: "Cost Per Contact",
    label: "totalCostPerContact",
    hoverText:
      "The amount of money spent on the ad divided by the number of contacts.",
  },
  {
    id: 12,
    title: "Amount Spent",
    label: "totalAmountSpent",
    hoverText:
      "The amount of money spent on the ad during the selected time frame.",
  },
];

export const doctorResourcesDefaultColors = [
  {
    backgroundColor: "rgba(240, 114, 35, 0.2)",
    color: "rgba(240, 114, 35, 1)",
  },
  {
    backgroundColor: "rgba(255, 180, 0, 0.2)",
    color: "rgba(255, 180, 0, 1)",
  },
  {
    backgroundColor: "rgba(154, 46, 184, 0.2)",
    color: "rgba(154, 46, 184, 1)",
  },
  {
    backgroundColor: "rgba(224, 34, 139, 0.2)",
    color: "rgba(249, 105, 164, 1)",
  },
  {
    backgroundColor: "rgba(23, 186, 224, 0.2)",
    color: "rgba(23, 186, 224, 1)",
  },
  {
    backgroundColor: "rgba(224, 34, 139, 0.2)",
    color: "rgba(224, 34, 139, 1)",
  },
];

export const VIEW_BY_OPTIONS = [
  {
    id: 1,
    label: "Creation Date",
    value: "Creation Date",
    selected: false,
  },
  {
    id: 2,
    label: "Follow Up Date",
    value: "Follow Up Date",
    selected: false,
  },
];
